import React, { Component } from 'react';
interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
  error?: Error;
}
class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    // Here you could log the error to an error reporting service
  }
  render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return <div className="min-h-screen flex items-center justify-center bg-gold-50 px-4" data-id="element-405">
          <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center" data-id="element-406">
            <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-407">
              Something went wrong
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-408">
              We apologize for the inconvenience. Please try refreshing the page
              or contact support if the problem persists.
            </p>
            <button onClick={() => window.location.reload()} className="btn-legacy-gold" data-id="element-409">
              Refresh Page
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;